export default "__VITE_ASSET__CLmbRCIg__"